import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div style={{paddingTop:"100px"}}>
      <h1>Welcome to RC</h1>
      <Link to="/products">View Products</Link>
    </div>
  );
};

export default Home;
